import React, { type FC, useEffect, useState } from "react";
import styles from "./LegalBannerDisclaimer.module.scss";
import {
    type LegalBannerDisclaimerDataType,
    type LegalBannerDisclaimerPayloadType,
    LegalBannerTableOrientation,
} from "../../shared-logic/types/FinanceTypes";
import { useCommonSelector } from "../../../common-deprecated/redux/commonStore";
import useClientSideRender from "../../../common-deprecated/hooks/useClientSideRender";
import { useWindowDimensionsContext } from "../../../common-deprecated/containers/WindowDimensionsProvider";

const LegalBannerDisclaimer: FC<{
    data: LegalBannerDisclaimerDataType | null;
    isPdf?: boolean;
}> = ({ data, isPdf }) => {
    const settings = useCommonSelector((state) => state.commonSettings.legalBanner);
    const isClient = useClientSideRender();
    const [orientation, setOrientation] = useState<LegalBannerTableOrientation>(LegalBannerTableOrientation.horizontal);

    const windowWidth = useWindowDimensionsContext().width || 992;

    useEffect((): void => {
        setOrientation(
            windowWidth <= 992 ? LegalBannerTableOrientation.vertical : LegalBannerTableOrientation.horizontal,
        );
    }, [windowWidth]);

    if (!data || !settings) return null;

    const payload: LegalBannerDisclaimerPayloadType = {
        title: settings?.title || "",
        dictionary: settings?.finance || {},
        finance: {
            image: settings?.image || {},
            finance: data.finance,
            text: data.disclaimer,
        },
        tableOrientation: data.tableOrientation,
    };

    const finance = JSON.stringify(payload.finance);

    return (
        <div className={styles.disclaimer}>
            {/* 
                COMPONENT IMPLEMENTATION IN ACCORDANCE WITH dxp-reference-guide #functional.mdx 
                Only render client-side to avoid hydration issues
            */}
            {isClient || isPdf ? (
                <dxp-foundation-components
                    key={`${finance}-${String(orientation)}`} // Force re-render using a key
                    data-component="legalBanner"
                    data-title={payload.title}
                    data-finance={finance}
                    data-table-orientation={payload.tableOrientation ?? orientation}
                />
            ) : null}
        </div>
    );
};

export default LegalBannerDisclaimer;
